module.exports = __webpack_public_path__ + "img/PXioNf1l-EmRPaQ,Cert_10005.19a64547.jpeg";